export type EmblaSlideAccessibilityProps = {
  "aria-hidden": boolean;
  inert?: true;
};

export function isEmblaSlideInView(
  slideIndex: number,
  slidesInView: number[],
): boolean {
  return slidesInView.includes(slideIndex);
}

export function getEmblaSlideAccessibilityProps(
  isVisible: boolean,
): EmblaSlideAccessibilityProps {
  if (isVisible) {
    return { "aria-hidden": false };
  }

  return {
    "aria-hidden": true,
    inert: true,
  };
}
